import React from 'react'

export default function Paging({ OnPageChange, pagingData, text = "Entries", children, loading = false }) {
    const isFirst = pagingData?.isFirstPage || pagingData?.pageCount == 0
    const isLast = pagingData?.isLastPage || pagingData?.pageCount == 0

    return (
        <div className="overflow-hidden rounded-xl border border-gray-200">
            {children}

            {pagingData &&
                <div className="w-full border-t border-gray-100 bg-gray-50">
                    <div className="flex flex-col items-center gap-3 p-3 sm:flex-row sm:justify-between">

                        {/* summary */}
                        <span className="text-center text-xs text-gray-500 sm:text-left sm:text-sm">
                            Showing <span className="font-semibold text-gray-700">{pagingData.firstItemOnPage}</span>
                            –<span className="font-semibold text-gray-700">{pagingData.lastItemOnPage}</span> of{" "}
                            <span className="font-semibold text-gray-700">{pagingData.totalItemCount}</span> {text}
                            <span className="ml-1 whitespace-nowrap text-gray-400">· Page {pagingData.pageNumber}/{pagingData.pageCount}</span>
                        </span>

                        {/* controls */}
                        <div className="inline-flex shrink-0">
                            <button
                                value={parseInt(pagingData.pageNumber) - 1}
                                onClick={OnPageChange}
                                disabled={loading || pagingData.pageCount == 0 || pagingData.isFirstPage}
                                className={`inline-flex h-9 items-center gap-1.5 rounded-s-lg px-3.5 text-sm font-medium text-white transition ${isFirst ? "cursor-not-allowed bg-brand-300" : "bg-brand-400 hover:bg-brand-500 active:scale-95"}`}
                            >
                                <svg className="h-3.5 w-3.5 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 5H1m0 0 4 4M1 5l4-4" />
                                </svg>
                                Prev
                            </button>
                            <button
                                value={parseInt(pagingData.pageNumber) + 1}
                                onClick={OnPageChange}
                                disabled={loading || pagingData.pageCount == 0 || pagingData.isLastPage}
                                className={`inline-flex h-9 items-center gap-1.5 rounded-e-lg border-s border-brand-600 px-3.5 text-sm font-medium text-white transition ${isLast ? "cursor-not-allowed bg-brand-300" : "bg-brand-400 hover:bg-brand-500 active:scale-95"}`}
                            >
                                Next
                                <svg className="h-3.5 w-3.5 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}